import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items = [] }) {
  return (
    <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-1.5 text-sm">
      {items.map((it, i) => (
        <span key={i} className="flex items-center gap-1.5">
          {it.to ? (
            <Link to={it.to} className="text-slate-300 hover:text-gold transition-colors">{it.label}</Link>
          ) : (
            <span className="text-gold">{it.label}</span>
          )}
          {i < items.length - 1 && <ChevronRight size={14} className="text-slate-300" />}
        </span>
      ))}
    </nav>
  );
}
